
import BaseStore from "jimbo/store";
import { makeObservable, observable, action } from "mobx";

import { ticketsClassFactory } from "schema/tickets";

export default class TicketsStore extends BaseStore {

    publishedContentId = null
    ticketsCsvDownload = null
    

    constructor({rootStore, baseApi}) {
        super({rootStore, baseApi});
        this.ticketsCsvDownload = ticketsClassFactory.createInstance("TicketCsvDownload", {initialData: {nrOfTickets: 20}});
    }


    setPublishedContentId = (id)=>{
        this.publishedContentId = id
    }

    getPublishedContentId = () => {
        return this.publishedContentId
    }
   
    fromJsonToObject = (initialData) => {
        const notification =  ticketsClassFactory.createInstance("Ticket", {initialData});
        return notification;
    }

    doCreateNewObject =  ({initValues}) => {
        return ticketsClassFactory.createInstance("Ticket", {});
    }

    createNewTicket = async() => {
        await this.baseApi.post({})
        this.loadObjects()
    }

    toggleSold = async(ticketId) => {
        await this.baseApi.toggleSold(ticketId)
        this.loadObjects()
    }
}